module.exports = __webpack_public_path__ + "img/skyCloudBg.e0c6e04e.jpg";